module.exports = __webpack_public_path__ + "static/email-template-receipt-esai-4ef25b0aadb68fa997853e8df2ec2f89.png";